import React, { useState } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import HelpIcon from "@mui/icons-material/Help";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";

import deliveredIcon from "./delivered-64px.png";
import onAWayIcon from "./fast-delivery-64px.png";
import notDeliveredIcon from "./not-delivered-64px.png";

import palette from "../theme/palette";

const orderStatusTranslationConformity = {
	CREATED: "1.СТВОРЕНИЙ",
	SUBMITTED_FOR_ASSEMBLY: "2.ПРИЙНЯТИЙ СКЛАДОМ",
	ASSEMBLY_STARTED: "3.СКЛАДАННЯ РОЗПОЧАТО",
	ASSEMBLY_FINISHED: "4.ЗБІРКА ЗАВЕРШЕНА",
	ON_A_WAY: "В ДОРОЗІ",
	DELIVERED: "ДОСТАВЛЕНИЙ",
	UNDELIVERED: "НЕДОСТАВЛЕНИЙ",
};

const legendItems = [
	{
		id: "go-to-icon",
		icon: (
			<Box sx={{ padding: "2px", height: "40px", width: "40px" }}>
				<LocationOnIcon
					fontSize="large"
					sx={{
						borderStyle: "solid",
						color: palette.primary.main,
						borderRadius: 2,
						borderColor: palette.primary.dark,
					}}
				/>
			</Box>
		),
		helpText: "Відстежити водія",
	},
	{
		id: "delivered-icon",
		icon: <img src={deliveredIcon} alt="ДОСТАВЛЕНО" height="40" />,
		helpText: "Замовлення доставлено",
	},
	{
		id: "on-a-way-icon",
		icon: <img src={onAWayIcon} alt="В ДОРОЗІ" height="40" />,
		helpText: "Замовлення у дорозі",
	},
	{
		id: "undelivered-icon",
		icon: <img src={notDeliveredIcon} alt="НЕ ДОСТАВЛЕНО" height="40" />,
		helpText: "Замовлення не було доставлено",
	},
	{
		id: "orderNumber coping hint",
		icon: <TipsAndUpdatesIcon fontSize="medium" color="warning" />,
		helpText: "Номер накладної можна скопіювати натиснувши на нього",
	},
];

const mapLegendRow = ({ id, icon, helpText }) => (
	<Box key={id}>
		<Box
			sx={{
				display: "flex",
				justifyContent: "left",
				alignItems: "center",
				gap: "15px",
				padding: "5px",
				width: "350px",
			}}
		>
			<Box sx={{ height: "40px", width: "40px" }}>{icon}</Box>
			<Box sx={{ textAlign: "left" }}>{helpText}</Box>
		</Box>
		<Divider />
	</Box>
);

const MapLegend = () => {
	const [isHelpExpanded, setIsHelpExpanded] = useState(false);
	return (
		<Box>
			<Box
				sx={{
					position: "absolute",
					top: "1rem",
					right: "50px",
					zIndex: 11,
				}}
			>
				<Button onClick={() => setIsHelpExpanded((val) => !val)}>
					<HelpIcon fontSize="large" />
				</Button>
			</Box>
			{isHelpExpanded && (
				<Box
					sx={{
						position: "absolute",
						top: "4rem",
						right: "50px",
						zIndex: 12,
					}}
				>
					<Paper>
						<Stack>{legendItems.map((row) => mapLegendRow(row))}</Stack>
					</Paper>
				</Box>
			)}
		</Box>
	);
};
export default MapLegend;
